import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let AllContactUsThunk = createAsyncThunk(
	"ContactUs/AllContactUsThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let url = `api/admin/contact_us?page=${arg.page}&per_page=12`;
			let res = await axios.get(url);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	}
);
